<!-- 表1填写 -->

<template>
  <div class="tabCage table3">
    <div class="tabTtl">
      <span>出版经营情况信息</span>
      <div class="tabBtns" style="float: right">
        <!-- <el-button type="primary" size="small" v-if="modifyFlag" class="importBtn"
          @click="getCode403HistoryData">导入历史数据</el-button> -->
      </div>
    </div>
    <div class="tip-div">
      <span class="tip-red"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
    </div>
    <el-form ref="paramCk" :model="params" :rules="rules">
      <div class="editArea">
        <table>
          <tr>
            <td colspan="2">项目</td>
            <td>{{ yearSet.year1 }}年</td>
            <td>{{ yearSet.year2 }}年</td>
          </tr>

          <!-- <tr>
            <td colspan="2">出版单位年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstTotalSales" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.firstTotalSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTotalSales" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.secondTotalSales"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr> -->

          <!-- <tr>
            <td colspan="2">出版单位年度利润（税后）总额（万元）</td>
            <td>
              <el-form-item prop="firstTotalProfit" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :precision="2"
                  v-model="params.firstTotalProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTotalProfit" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :precision="2"
                  v-model="params.secondTotalProfit"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr> -->

          <tr>
            <td rowspan="8">连续型电子出版物<br />年度销售收入（万元）</td>
            <td>连续型电子出版物<br />国内发行和销售收入</td>
            <td>
              <el-form-item prop="firstSales1" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.firstSales1"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales1" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.secondSales1"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>海外发行收入</td>
            <td>
              <el-form-item prop="firstSales2" :show-message="false">
                <el-input-number
                  v-model="params.firstSales2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales2" :show-message="false">
                <el-input-number
                  v-model="params.secondSales2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>出让版权的收入</td>
            <td>
              <el-form-item prop="firstSales3" :show-message="false">
                <el-input-number
                  v-model="params.firstSales3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales3" :show-message="false">
                <el-input-number
                  v-model="params.secondSales3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>与出版相关活动收入</td>
            <td>
              <el-form-item prop="firstSales4" :show-message="false">
                <el-input-number
                  v-model="params.firstSales4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales4" :show-message="false">
                <el-input-number
                  v-model="params.secondSales4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>连续型电子出版物<br />及新媒体网站上<br />所做广告收入</td>
            <td>
              <el-form-item prop="firstSales5" :show-message="false">
                <el-input-number
                  v-model="params.firstSales5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales5" :show-message="false">
                <el-input-number
                  v-model="params.secondSales5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>提供内容审校加工等<br />各种服务的收入</td>
            <td>
              <el-form-item prop="firstSales6" :show-message="false">
                <el-input-number
                  v-model="params.firstSales6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales6" :show-message="false">
                <el-input-number
                  v-model="params.secondSales6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>其他收入</td>
            <td>
              <el-form-item prop="firstSales7" :show-message="false">
                <el-input-number
                  v-model="params.firstSales7"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales7" :show-message="false">
                <el-input-number
                  v-model="params.secondSales7"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-form-item prop="firstSales" :show-message="false">
                <el-input-number
                  v-model="params.firstSales"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSales" :show-message="false">
                <el-input-number
                  v-model="params.secondSales"
                  disabled
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="7">连续型电子出版物年度支出（万元）</td>
            <td>出版团队的人员<br />成本费用<br />（包括工资、福利、奖金等）</td>
            <td>
              <el-form-item prop="firstPay1" :show-message="false">
                <el-input-number
                  v-model="params.firstPay1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay1" :show-message="false">
                <el-input-number
                  v-model="params.secondPay1"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>房租水电等<br />运营成本费用</td>
            <td>
              <el-form-item prop="firstPay2" :show-message="false">
                <el-input-number
                  v-model="params.firstPay2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay2" :show-message="false">
                <el-input-number
                  v-model="params.secondPay2"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>获取内容及<br />审校加工等<br />各种劳务的支出</td>
            <td>
              <el-form-item prop="firstPay3" :show-message="false">
                <el-input-number
                  v-model="params.firstPay3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay3" :show-message="false">
                <el-input-number
                  v-model="params.secondPay3"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>印刷压盘包装等费用</td>
            <td>
              <el-form-item prop="firstPay4" :show-message="false">
                <el-input-number
                  v-model="params.firstPay4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay4" :show-message="false">
                <el-input-number
                  v-model="params.secondPay4"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>新媒体上的投入</td>
            <td>
              <el-form-item prop="firstPay5" :show-message="false">
                <el-input-number
                  v-model="params.firstPay5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay5" :show-message="false">
                <el-input-number
                  v-model="params.secondPay5"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>其他支出</td>
            <td>
              <el-form-item prop="firstPay6" :show-message="false">
                <el-input-number
                  v-model="params.firstPay6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay6" :show-message="false">
                <el-input-number
                  v-model="params.secondPay6"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>合计</td>
            <td>
              <el-form-item prop="firstPay" :show-message="false">
                <el-input-number
                  v-model="params.firstPay"
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondPay" :show-message="false">
                <el-input-number
                  v-model="params.secondPay"
                  disabled
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">
              连续型电子出版物年税费（万元）<br />
              <span style="color: red">指与连续型电子出版相关的企业所得缴纳税费，含营业税和所得税。</span>
            </td>
            <td>
              <el-form-item prop="firstTax" :show-message="false">
                <el-input-number v-model="params.firstTax" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondTax" :show-message="false">
                <el-input-number v-model="params.secondTax" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">连续型电子出版物<br />年度利润（税后）总额（万元）</td>
            <td>
              <el-form-item prop="firstProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.firstProfit" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondProfit" :inline-message="true">
                <el-input-number controls-position="right" :precision="2" v-model="params.secondProfit" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">获得基金类资助（万元）</td>
            <td>
              <el-form-item prop="firstFund" :show-message="false">
                <el-input-number v-model="params.firstFund" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondFund" :show-message="false">
                <el-input-number v-model="params.secondFund" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">主办主管单位给与的经费支持（万元）</td>
            <td>
              <el-form-item prop="firstSuperior" :show-message="false">
                <el-input-number v-model="params.firstSuperior" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSuperior" :show-message="false">
                <el-input-number v-model="params.secondSuperior" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="3">载体出版<br />经营情况</td>
            <td>销售数量（套/张）</td>
            <td>
              <el-form-item prop="firstSalesVolumes" :show-message="false">
                <el-input-number
                  v-model="params.firstSalesVolumes"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSalesVolumes" :show-message="false">
                <el-input-number
                  v-model="params.secondSalesVolumes"
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstZtcbSales" :show-message="false">
                <el-input-number v-model="params.firstZtcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbSales" :show-message="false">
                <el-input-number v-model="params.secondZtcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-form-item prop="firstZtcbProfit" :show-message="false">
                <el-input-number v-model="params.firstZtcbProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbProfit" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="5">
              载体出版发行的渠道及占比
              <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>新华书店%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>馆配商%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>邮局%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne2" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne2"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne2" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne2"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>其他%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne3" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne3"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne3" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne3"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td>自办发行%</td>
            <td>
              <el-form-item prop="firstZtcbDistributionChanne4" :show-message="false">
                <el-input-number
                  v-model="params.firstZtcbDistributionChanne4"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondZtcbDistributionChanne4" :show-message="false">
                <el-input-number
                  v-model="params.secondZtcbDistributionChanne4"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="2">
              信息网络出版<br />
              经营情况
            </td>
            <td>年销售收入（万元）</td>
            <td>
              <el-form-item prop="firstWlcbSales" :show-message="false">
                <el-input-number v-model="params.firstWlcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbSales" :show-message="false">
                <el-input-number v-model="params.secondWlcbSales" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>年利润总额（万元）</td>
            <td>
              <el-form-item prop="firstWlcbProfit" :show-message="false">
                <el-input-number v-model="params.firstWlcbProfit" controls-position="right" :precision="2" size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbProfit" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbProfit"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td rowspan="2">
              信息网络出版渠道及占比
              <br />
              <br /><span style="color: red">（请填写%之前的数值）</span>
            </td>
            <td>互联网网络营销平台%</td>
            <td>
              <el-form-item prop="firstWlcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.firstWlcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbDistributionChanne" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbDistributionChanne"
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>自办发行%</td>
            <td>
              <el-form-item prop="firstWlcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.firstWlcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondWlcbDistributionChanne1" :show-message="false">
                <el-input-number
                  v-model="params.secondWlcbDistributionChanne1"
                  controls-position="right"
                  :precision="2"
                  size="small">
                </el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="4" style="text-align: left; padding-left: 10px">
              <span style="color: red"
                >如果在网络营销平台同时发行载体出版物，对应销售收入及利润总额也应计入网络出版相关细目。</span
              >
            </td>
          </tr>

          <tr>
            <td colspan="2">国内发行数量(套)</td>
            <td>
              <el-form-item prop="firstIssueQuantityCn" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.firstIssueQuantityCn"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondIssueQuantityCn" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.secondIssueQuantityCn"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2">国内发行单价(元)</td>
            <td>
              <el-form-item prop="firstUnitPrice" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.firstUnitPrice"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondUnitPrice" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="2"
                  v-model="params.secondUnitPrice"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2">海外发行数量(套)</td>
            <td>
              <el-form-item prop="firstIssueQuantityFn" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.firstIssueQuantityFn"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondIssueQuantityFn" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.secondIssueQuantityFn"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>

          <tr>
            <td colspan="2">收文量</td>
            <td>
              <el-form-item prop="firstSwl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.firstSwl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondSwl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.secondSwl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2">录用量</td>
            <td>
              <el-form-item prop="firstLyl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.firstLyl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondLyl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.secondLyl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td colspan="2">发文量</td>
            <td>
              <el-form-item prop="firstFwl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.firstFwl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
            <td>
              <el-form-item prop="secondFwl" :inline-message="true">
                <el-input-number
                  controls-position="right"
                  :min="0"
                  :precision="0"
                  v-model="params.secondFwl"
                  size="small"></el-input-number>
              </el-form-item>
            </td>
          </tr>
        </table>
      </div>
      <div class="headBar">
        <span>申报人信息</span>
      </div>
      <div class="editArea newEditArea">
        <div class="editBox">
          <p class="edName">申报人：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.personnel" placeholder="请输入申报人"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">联系方式：</p>
          <div class="edInp">
            <el-input size="small" v-model="declare.contact" placeholder="请输入申报人联系方式"></el-input>
          </div>
        </div>
        <div class="editBox">
          <p class="edName">申报时间：</p>
          <div class="edInp">
            <el-input size="small" v-model="params.updatedAt" :disabled="true"></el-input>
          </div>
        </div>
      </div>
    </el-form>

    <div class="subArea">
      <el-button @click="goBack" size="small">返回</el-button>
      <el-button v-if="modifyFlag" type="primary" @click="editSave('paramCk')" size="small" :disabled="submiting">
        <span v-if="submiting">提交中</span>
        <span v-else>保存</span>
        <i v-if="submiting" class="el-icon-loading"></i>
      </el-button>
    </div>
  </div>
</template>

<script>
import { bsParams, paramsRule } from "@/components/LongParams/paramsSEt3";
import {
  ssSave3,
  ssRead3,
  code403HistoryData,
  getLxdzModifyFlagByPublication, // zym.判断数据是否可以修改
} from "@/api/pressRole/pressSuccessive";
export default {
  data() {
    return {
      params: bsParams,
      rules: paramsRule,
      submiting: false,

      yearSet: {
        year1: "",
        year2: "",
      },
      declare: {
        personnel: "",
        contact: "",
      },

      modifyFlag: false,
    };
  },
  watch: {
    "params.areaDate": function (dat) {
      this.params.startYyDate = dat[0];
      this.params.endYyDate = dat[1];
    },
  },
  methods: {
    editSave: function (name) {
      let that = this;

      this.$refs[name].validate((valid) => {
        if (valid) {
          this.params.publishId = this.$route.query.pressId;
          this.params.publishMaterialId = this.$route.query.mtId;

          this.params.firstYear = this.yearSet.year1;
          this.params.secondYear = this.yearSet.year2;
          if (!this.declare.personnel) {
            this.$message.error("申报人姓名必填");
            return;
          }
          // if (!/^1[34578]\d{9}$/.test(this.declare.contact)) {
          //   this.$message.error('请填写正确的手机号');
          //   return
          // }
          if (!this.declare.contact) {
            this.$message.error("申报人联系方式必填");
            return;
          }

          let bFirst = that.params.firstTotalSales > 500000;
          let bSecond = that.params.secondTotalSales > 500000;
          if (bFirst || bSecond) {
            that.$confirm("请确认年销售收入填写的是否正确。", "提示", {
              confirmButtonText: "确定", //确认按钮的文字
              showCancelButton: false, //是否显示取消按钮
              showClose: false, //是否显示关闭按钮
              closeOnClickModal: false, //是否可以通过点击空白处关闭弹窗
              type: "error",
            });
            return;
          }

          let msg = "请再次确认页面中所输入的金额单位为万元。";
          that
            .$confirm(msg, "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
            .then(() => {
              ssSave3({
                data: that.params,
                // plxdzfinance: this.params,
                organizationPersonnel: that.declare,
              })
                .then((response) => {
                  console.log("response=", JSON.stringify(response));
                  let tipCode = response.payload.tipCode;
                  let tipMessage = response.payload.tipMessage;
                  if (tipCode == "fail") {
                    that.$message({
                      message: tipMessage,
                      type: "error",
                    });
                  } else {
                    that.submiting = false;
                    that.$message({
                      message: "保存成功！",
                      type: "success",
                    });

                    that.goBack();
                  }
                })
                .catch((error) => {
                  that.submiting = false;
                });
            })
            .catch(() => {});
        } else {
          return false;
        }
      });
    },
    //获取历史导入数据
    getCode403HistoryData: function () {
      let that = this;
      this.imgId = "";
      const loading = this.$loading({
        lock: true,
        text: "导入中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      code403HistoryData({
        publishMaterialId: this.$route.query.mtId,
      })
        .then((response) => {
          loading.close();
          // 旧数据打底，历史数据覆盖，旧ID删除，新publishMaterialId替换 - Hsj
          that.params = {
            ...that.params,
            ...response.plxdzfinance,
            publishMaterialId: that.$route.query.mtId,
          };
          // that.imgId = response.plxdzPublication.yyzzId;
          if (response.pOrganizationPersonnel !== null) {
            that.declare.contact = response.pOrganizationPersonnel.contact;
            that.declare.personnel = response.pOrganizationPersonnel.personnel;
            that.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
          that.layChange();
        })
        .catch((error) => {
          that.submiting = false;
        });
    },
    tabReEdit: function () {
      ssRead3({
        publishMaterialId: this.$route.query.mtId,
        judgeModify: true,
      }).then((response) => {
        // console.log('1')
        if (response.plxdzFinance) {
          // 新增
          if (this.$route.query.pgress == 1) {
            // 处理年份
            this.yearSet.year1 = response.plxdzFinance.firstYear;
            this.yearSet.year2 = Number(response.plxdzFinance.firstYear) + 1;
          } else {
            // console.log('2')
            this.modifyFlag = response.modifyFlag;
            this.params = response.plxdzFinance;

            // 处理年份
            this.yearSet.year1 = this.params.firstYear;
            this.yearSet.year2 = Number(this.params.firstYear) + 1;

            this.declare.contact = response.pOrganizationPersonnel.contact;
            this.declare.personnel = response.pOrganizationPersonnel.personnel;
            this.params.updatedAt = response.pOrganizationPersonnel.updatedAt;
          }
        } else {
          this.modifyFlag = response.modifyFlag;
          // console.log('3')
        }
      });
    },

    fileTdSet: function (id) {
      this.params.yyzzId = id;
    },

    layChange: function () {
      if (this.isNot[this.params.isIndependentLP] == "是") {
        this.layDasion = 1;
      } else {
        this.layDasion = 2;
      }
    },

    goBack: function () {
      this.$router.go(-1);
    },
    // zym.判断是否可以修改
    getLxdzModifyFlagByPublication: function () {
      console.log("getLxdzModifyFlagByPublication...");
      let vm = this;
      getLxdzModifyFlagByPublication({
        publishMaterialId: this.$route.query.mtId, // *publicationOrganizationMaterial的主键
      }).then((response) => {
        vm.modifyFlag = response.payload;
      });
    },
  },
  created: function () {
    // zym.判断是否可以修改
    // this.getLxdzModifyFlagByPublication();

    this.tabReEdit();
    if (this.$route.query.pgress == 2) {
      console.log("进来1...");
      // this.tabReEdit();
    } else {
      console.log("进来2...");
      this.modifyFlag = true;
    }

    // let newDate = new Date();
    // this.yearSet.year1 = newDate.getFullYear() - 2;
    // this.yearSet.year2 = newDate.getFullYear() - 1;
  },

  beforeDestroy: function () {
    for (let key in this.params) {
      this.params[key] = "";
    }
  },
};
</script>

<style lang="scss">
@import "src/styles/pressRoleE";

.table3 .editArea {
  text-align: center;
}

.table3 .editArea table {
  width: 80%;
  margin: 30px auto;
  border-collapse: collapse;
}

.table3 .editArea table td {
  border: 1px solid #e8e8e8;
  height: 45px;
}

.table3 .el-input-number {
  width: 240px;
}

.table3 .el-input-number input {
  border-radius: 0px;
}

.tabCage .editArea table .edInp .el-input {
  width: auto;
}

.table3 {
  .headBar {
    padding: 0px 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    color: #666666;
    margin-top: 12px;
  }

  .newEditArea {
    width: 80%;
    margin: 0 auto;
    padding: 30px;

    .editBox {
      width: 100%;
      height: auto;
      overflow: hidden;

      p {
        float: left;
        width: 100px;
        text-align: right;
      }

      .edInp {
        width: 300px;
        float: left;
        margin: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ssTab3.vue?1118dbdd